const Routes = {
  LINK_LIST: '/' ,
  ADD_NEW_LINK: '/addNewLink',
};

const Themes = {
  LIGHT: 'light',
  DARK: 'dark',
};

export { Routes, Themes };
